import { z } from 'zod';

// ---------------------------------------------------------------------------
// Params & Queries
// ---------------------------------------------------------------------------

export const listIdParam = z.object({
  id: z.string().uuid(),
});

export const listListsQuery = z.object({
  hub_id: z.string().uuid(),
});

export const listListContactsQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(100).default(25),
});

export const createListBody = z.object({
  hub_id: z.string().uuid(),
  list_name: z.string().min(1),
  description: z.string().nullable().optional(),
});

export const updateListBody = z.object({
  list_name: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
});

export const addListContactsBody = z.object({
  contact_ids: z.array(z.string().uuid()).min(1),
});

export const removeListContactsBody = z.object({
  contact_ids: z.array(z.string().uuid()).min(1),
});

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface OutboundList {
  list_id: string;
  hub_id: string;
  list_name: string;
  description: string | null;
  contact_count: number;
  created_at: string;
  updated_at: string;
}

export interface ListListsResponse {
  lists: OutboundList[];
}

export interface CreateListResponse {
  list_id: string;
}

export interface ListContactEntry {
  list_contact_id: string;
  contact_id: string;
  contact_name: string;
  phone: string | null;
  email: string | null;
  instagram_sid: string | null;
  enabled: boolean;
  added_at: string;
}

export interface ListListContactsResponse {
  contacts: ListContactEntry[];
  total: number;
  page: number;
  per_page: number;
}
